module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"expand_review":"리뷰 더보기","collapse_review":"리뷰 접기","user_display_name_message_html":"<b>%{user_display_name}</b>님의 리뷰 입니다.","user_grade":"회원 등급","author_grade":"작성자 등급"}}')
  delete Component.options._Ctor
}
